import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../utils/axios-base-query';

const baseApi = createApi({
  reducerPath: 'premierBaseApi',
  baseQuery: axiosBaseQuery({
    baseUrl: ''
  }),
  endpoints: () => ({})
});

export { baseApi };


